import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_PROMO_GOODS_SAGA } from "../sagaTypes";
import { loaderAction, promoGoodsFormAction, promoFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { PROMO_GOODS_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_p_goods`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdatePromoGoods(args) {
    const user = yield select(state => state.user);
    const promo_form = yield select(state => state.promo_form);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('promo_id', args.data.promo_id);
        formData.append('goods', args.data.goods);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму настройки товаров промоакции
            yield put(promoGoodsFormAction(PROMO_GOODS_FORM_INITIAL));
            // Обновляем количество отмеченных товаров
            yield put(promoFormAction({
                ...promo_form,
                goods: args.data.goods_count
            }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdatePromoGoods() {
    yield takeLatest(UPDATE_PROMO_GOODS_SAGA, workerUpdatePromoGoods);
}